import React from "react"
import { TextField, MenuItem } from "@mui/material"

import useInnerLengthsByOuterLengthsConfiguration from "@secureo/common/hooks/cylinderConfigurations/useInnerLengthsByOuterLengthsConfiguration"

import { InnerLengthsByOuterLengths } from "@secureo/common/typings/Product"
import { GridTemplateRowName } from "../LockingSystemMatrix"
import LockingSystemItemWrapper from "../LockingSystemItemWrapper"
import StyledLockingSystemCell from "../StyledLockingSystemCell"

const InnerAndOuterLengthConfiguration = ({
	isLoading,
	uuid,
	gridRowName,
	selectedOuterLength,
	selectedInnerLength,
	innerLengthsByOuterLengths,
	setSelectedOuterLength,
	setSelectedInnerLength,
}: Props) => {
	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(uuid, selectedOuterLength)
	}

	const onInnerLengthChange = (selectedInnerLength: number) => {
		setSelectedInnerLength(uuid, selectedInnerLength)
	}

	const {
		availableOuterLengths,
		availableInnerLengths,
		outerLengthInputProps,
		innerLengthInputProps,
	} = useInnerLengthsByOuterLengthsConfiguration(
		innerLengthsByOuterLengths,
		selectedOuterLength,
		selectedInnerLength,
		onOuterLengthChange,
		onInnerLengthChange,
	)

	return (
		<>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="outerLength">
				<LockingSystemItemWrapper>
					<TextField
						label="A"
						{...outerLengthInputProps}
						margin="normal"
						variant="filled"
						select
						fullWidth
						disabled={isLoading || !setSelectedOuterLength}
						style={{ marginTop: 0 }}
					>
						{availableOuterLengths.map((outerLength) => {
							return (
								<MenuItem key={outerLength} value={outerLength}>
									{outerLength} mm
								</MenuItem>
							)
						})}
					</TextField>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>

			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="innerLength">
				<LockingSystemItemWrapper>
					<TextField
						label="I"
						{...innerLengthInputProps}
						margin="normal"
						variant="filled"
						select
						fullWidth
						disabled={isLoading || !setSelectedInnerLength}
						style={{ marginTop: 0 }}
					>
						{availableInnerLengths.map((innerLength) => (
							<MenuItem key={innerLength} value={innerLength}>
								{innerLength} mm
							</MenuItem>
						))}
					</TextField>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>
		</>
	)
}

interface Props {
	isLoading: boolean
	uuid: string
	gridRowName: GridTemplateRowName
	selectedOuterLength: number
	selectedInnerLength: number
	innerLengthsByOuterLengths: InnerLengthsByOuterLengths
	setSelectedOuterLength?: (uuid: string, selectedOuterLength: number) => void
	setSelectedInnerLength?: (uuid: string, selectedOuterLength: number) => void
}

export default InnerAndOuterLengthConfiguration
